// extracted by css-extract-rspack-plugin
export default {"customMultiSelect":"MultiSelectStyles_customMultiSelect__FDyxy"};